import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './App.css'
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Footer from "./Components/Footer";
import University from "./Components/University";
import Personal from "./Components/Personal";
import Contact from "./Components/Contact";
import About from "./Components/About";
import Project from "./Components/Project";
import Publications from "./Components/Publications";
import GitHubProjects from "./Components/GitHubProjects";
import Archive from "./Components/Archive";
import EmacsNavigation from "./Components/EmacsNavigation";
import PodBox from "./Components/PodBox";


ReactDOM.render(
  <React.StrictMode>
    <div id="page-container">
      <div id="content-wrap">
        <Router>
          <EmacsNavigation />
          <Switch>
            <Route exact path="/" component={App} />
            <Route path="/University" component={University} />
            <Route path="/Personal" component={Personal} />
            <Route path="/Contact" component={Contact} />
            <Route path="/About" component={About} />
            <Route path="/Project" component={Project} />
            <Route path="/Publications" component={Publications} />
            <Route path="/GitHub" component={GitHubProjects} />
            <Route path="/Archive" component={Archive} />
            <Route path="/PodBox" component={PodBox} />
          </Switch>
          <Footer />
        </Router>
      </div>
    </div>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
